import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.75 1C11.75 0.447716 11.3023 4.97911e-08 10.75 0C10.1977 -4.97911e-08 9.75 0.447716 9.75 1L11.75 1ZM11.75 18L11.75 1L9.75 1L9.75 18L11.75 18Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.75 15L10.75 19L6.75 15",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }